import HeroModule from './HeroModule';

export * from './HeroModule';
export default HeroModule;
